import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "size-full flex flex-col overflow-y-auto scroll-smooth no-scrollbar" };
const _hoisted_2 = { class: "flex-shrink-0 pt-3 pb-4" };
const _hoisted_3 = { class: "flex flex-wrap gap-2" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "font-medium" };
const _hoisted_6 = { class: "flex-1 pt-4" };
const _hoisted_7 = { class: "space-y-4" };
const _hoisted_8 = { class: "relative" };
const _hoisted_9 = ["max"];
const _hoisted_10 = { class: "relative" };
const _hoisted_11 = ["max"];
import { ref, watch } from 'vue';
import { X } from 'lucide-vue-next';
import { useHomeFilterStore } from './homeFilterStore';
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-filter-dialog-year',
    setup(__props) {
        const homeFilterStore = useHomeFilterStore();
        const currentYear = new Date().getFullYear();
        const yearRanges = [
            { label: '1959-1980', min: '1959', max: '1980' },
            { label: '1981-2000', min: '1981', max: '2000' },
            { label: '2001-2010', min: '2001', max: '2010' },
            { label: '2011-2020', min: '2011', max: '2020' },
            { label: '2021-2025', min: '2021', max: '2025' },
        ];
        const minYearInput = ref(homeFilterStore.minYear || '');
        const maxYearInput = ref(homeFilterStore.maxYear || '');
        // Watch for changes in store values to update inputs
        watch(() => homeFilterStore.minYear, (newVal) => {
            minYearInput.value = newVal || '';
        });
        watch(() => homeFilterStore.maxYear, (newVal) => {
            maxYearInput.value = newVal || '';
        });
        const isRangeSelected = (range) => {
            return homeFilterStore.minYear === range.min && homeFilterStore.maxYear === range.max;
        };
        const selectYearRange = (range) => {
            homeFilterStore.minYear = range.min;
            homeFilterStore.maxYear = range.max;
            minYearInput.value = range.min;
            maxYearInput.value = range.max;
        };
        const updateMinYear = () => {
            const value = minYearInput.value;
            homeFilterStore.minYear = value && !isNaN(Number(value)) && Number(value) >= 1959 ? value : '';
        };
        const updateMaxYear = () => {
            const value = maxYearInput.value;
            homeFilterStore.maxYear = value && !isNaN(Number(value)) && Number(value) <= currentYear ? value : '';
        };
        const clearMinYear = () => {
            minYearInput.value = '';
            homeFilterStore.minYear = '';
        };
        const clearMaxYear = () => {
            maxYearInput.value = '';
            homeFilterStore.maxYear = '';
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(yearRanges, (range) => {
                            return _createElementVNode("button", {
                                key: range.label,
                                onClick: ($event) => (selectYearRange(range)),
                                class: _normalizeClass([
                                    'w-auto px-2 py-1 text-left rounded-lg border transition-all',
                                    isRangeSelected(range)
                                        ? 'bg-primary2 border-primary2 text-white'
                                        : 'bg-white border-badge/30 text-badge hover:border-primary2 hover:bg-primary2/5'
                                ])
                            }, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(range.label), 1)
                            ], 10, _hoisted_4);
                        }), 64))
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                            _cache[2] || (_cache[2] = _createElementVNode("label", { class: "block text-sm font-medium text-badge mb-2" }, "Minimum Year", -1)),
                            _createElementVNode("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((minYearInput).value = $event)),
                                    type: "number",
                                    placeholder: "1959",
                                    min: "1959",
                                    max: _unref(currentYear),
                                    step: "1",
                                    class: "w-full p-2 pr-20 border border-badge/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary2 focus:border-primary2 text-badge",
                                    onInput: updateMinYear
                                }, null, 40, _hoisted_9), [
                                    [
                                        _vModelText,
                                        minYearInput.value,
                                        void 0,
                                        { number: true }
                                    ]
                                ]),
                                (minYearInput.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: clearMinYear,
                                        class: "absolute right-3 top-1/2 transform -translate-y-1/2 p-1 hover:bg-badge/10 rounded-full transition-colors",
                                        title: "Clear minimum year"
                                    }, [
                                        _createVNode(_unref(X), { class: "size-4 text-badge/70 hover:text-badge" })
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", null, [
                            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "block text-sm font-medium text-badge mb-2" }, "Maximum Year", -1)),
                            _createElementVNode("div", _hoisted_10, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((maxYearInput).value = $event)),
                                    type: "number",
                                    placeholder: "2025",
                                    min: "1959",
                                    max: _unref(currentYear),
                                    step: "1",
                                    class: "w-full p-2 pr-20 border border-badge/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary2 focus:border-primary2 text-badge",
                                    onInput: updateMaxYear
                                }, null, 40, _hoisted_11), [
                                    [
                                        _vModelText,
                                        maxYearInput.value,
                                        void 0,
                                        { number: true }
                                    ]
                                ]),
                                (maxYearInput.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: clearMaxYear,
                                        class: "absolute right-3 top-1/2 transform -translate-y-1/2 p-1 hover:bg-badge/10 rounded-full transition-colors",
                                        title: "Clear maximum year"
                                    }, [
                                        _createVNode(_unref(X), { class: "size-4 text-badge/70 hover:text-badge" })
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
